export default async function registerUser(username, email, password, setters) {
  const url = (process.env.REACT_APP_API_URL || '') + '/api/user';
  const data = { username, email, password };
  const { setLoading, setUser, setError } = setters;

  setLoading(true);

  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
    .then((response) => response.json())
    .then((data) => {
      if (data && data.user) {
        setLoading(false);
        localStorage.setItem('token', data.token);
        setUser(data.user);
      } else if (data.validationErrors) {
        setError(data.validationErrors);
        setLoading(false);
        return;
      } else {
        throw new Error('Error during fetching user.');
      }
    })
    .catch((err) => {
      setError({ error: err.message });
      setLoading(false);
    });
}
